<template>
	<div>

        <template v-if="distribuicao">

            <cadastro-laudo-distribuicao
                :id_medico="item.id_pessoa"
                :nome_medico="item.st_nome_exibicao"
                @fechar="distribuicao = false" />

        </template>

        <template v-else>

            <config-main-title>
                Agendas Compartilhadas
            </config-main-title>

            <div v-if="!em_edicao">

                <div class="row mb-3">
                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-filter"
                            type="select"
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            placeholder="Todas"
                            v-model="especialidade" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-search" v-model="search" />
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn text-nowrap" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn text-nowrap" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <button type="button" class="btn btn-outline-success" @click="addNewItem ()">Incluir</button>
                    </div>
                </div>

            </div>

            <div v-if="!em_edicao && !lista_dados.length">
                <az-empty-state action="Incluir" msg="Nenhum agenda compartilhada identificada." :method="addNewItem" />
            </div>

            <div v-if="!em_edicao && lista_dados.length">

                <div class="list-group mb-3 az-anime-surgir mb-3" v-if="!em_edicao">
                    <li class="list-group-item d-flex justify-content-between" :class="prestador.medico_unidade && prestador.medico_unidade.fl_ativo ? '' : 'list-group-item-secondary'"
                        v-for="(prestador, ip) in lista_dados" :key="ip">
                        <span>
                            <a href="#" @click.prevent="editar(prestador)" class="h5 card-link mb-0 mr-3">
                                {{ prestador.st_nome_exibicao }}
                            </a>
                            <small class="text-muted" v-for="(esp, ie) in prestador.medico_especialidade" :key="ie">
                                <span v-if="ie">/</span>
                                {{ esp.especialidade.st_especialidade }}
                            </small>
                            <span v-if="!prestador.medico_especialidade.length"
                                data-toggle="tooltip" data-placement="top" title="Nenhuma especialidade habilitada.">
                                <i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                            </span>
                        </span>
                        <span v-if="prestador.medico_unidade">
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" :id="'ativo' + ip"
                                    v-model="prestador.medico_unidade.fl_ativo" @change="toggle_medico(prestador.medico_unidade)">
                                <label class="custom-control-label" :for="'ativo' + ip"></label>
                            </div>
                        </span>
                    </li>
                </div>

                <pre v-if="1 == 0 && !em_edicao">{{ lista_dados }}</pre>

            </div>

            <!-- Formulário -->
            <div v-if="em_edicao">
                <az-empty-state v-if="!item" />

                <div class="card" style="padding: 0px;" v-else>

                    <div class="card-header lead bg-success text-white" v-if="!item.id_pessoa">
                        Novo
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col col-12 col-md-9">
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input label="Nome da Agenda" :validate="validate" required v-model="item.st_nome_exibicao" rules2="['nome']"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <AzInput label="Conselho"
                                    type="select"
                                    optionsMode="aql"
                                    service="conselhos.index"
                                    optionsData="id_conselho"
                                    optionsDisplay="st_sigla"
                                    v-model="item.id_conselho"
                                    required
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Agenda de Centro Cirúrgico"
                                    :edicao="!item.fl_agenda_compart_infusao"
                                    v-model="item.fl_agenda_compart_centro_cirurg" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Agenda de Poltrona de Infusão"
                                    :edicao="!item.fl_agenda_compart_centro_cirurg"
                                    v-model="item.fl_agenda_compart_infusao" />
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Não exibir na recepção (para atendimento)"
                                    v-model="item.fl_block_atend" />
                            </div>
                        </div>

                        <!-- Especialidades -->
                        <az-sub-title class="mt-3" title="Especialidades" :big="true" />
                        <especialidades-vinculadas v-model="item.medico_especialidade" />

                        <!-- Restrição para Paicentes -->
                        <az-sub-title class="mt-3" title="Restrição de Pacientes" :big="true" />
                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Idade Mínima"
                                    placeholder="0"
                                    v-model="item.medico_unidade.in_paciente_idade_minima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Idade Máxima"
                                    placeholder="999"
                                    v-model="item.medico_unidade.in_paciente_idade_maxima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="sexo"
                                    placeholder="Qualquer"
                                    label="Sexo do Paciente"
                                    v-model="item.medico_unidade.ch_paciente_sexo" />
                            </div>
                        </div>

                        <!-- Instruções -->
                        <template v-if="item.medico_unidade">
                            <az-sub-title class="mt-3" title="Instruções" :big="true" />

                            <az-input
                                type="textarea"
                                rows="3"
                                v-model="item.medico_unidade.st_instrucao"
                                :validate="validate" />

                            <az-input
                                label="Agenda On-Line"
                                type="textarea"
                                rows="3"
                                v-model="item.medico_unidade.st_instrucao_agenda_online"
                                :validate="validate" />

                            <div v-if="1 == 0">
                                <vue-markdown />
                            </div>

                        </template>

                        <!-- Google calendar -->
                        <az-input label="Id do Calendário do Google"
                            :validate="validate"
                            v-model="item.cadastro.st_google_calendar"
                            :edicao="!item.cadastro.fl_google_calendar"
                            v-if="item.google_calendar"
                        >
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn" :class="item.cadastro.fl_google_calendar ? 'btn-outline-success' : 'btn-outline-primary'" type="button" @click="ativar_google_calendar ()">
                                        <i class="fas mx-2" :class="item.cadastro.fl_google_calendar ? 'fa-calendar-times' : 'fa-calendar-check'"></i>
                                        {{item.cadastro.fl_google_calendar ? '' : 'Ativar'}}
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <!-- Campos Customizados -->
                        <div v-if="item.campos_customizados" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" :big="true" />
                                <formulario
                                    :gutters="true"
                                    :validate="validate"
                                    v-model="item.campos_customizados.js_campos"
                                    :saved="true"
                                    mode="fixed"
                                    :config="true" />
                            </div>
                        </div>

                    </div>

                    <pre v-if="1 == 0">{{ item }}</pre>

                    <!-- Botões de Atualização -->

                    <nav class="navbar fixed-bottom navbar-light bg-light pb-3 d-flex justify-content_between">
                        <div>
                            <az-submit @click="atualizar ()" class="mr-2">{{ item.id_pessoa ? 'Atualizar' : 'Incluir' }}</az-submit>
                            <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                            <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('medico', item.id_pessoa)"
                                v-if="item.id_pessoa">
                                Log
                            </button>
                        </div>
                        <div class="d-flex" v-if="item.id_pessoa">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block"
                                data-toggle="tooltip" data-placement="top" title="Distribuição de Laudo."
                                @click="distribuicao = true">
                                <i class="fa-solid fa-diagram-project mr-2"></i>
                                Distribuição de Laudo
                            </button>
                            <button type="button" class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block"
                                data-toggle="tooltip" data-placement="top" title="Profissionais disponíveis para essa agenda compartilhada."
                                @click="medico_lista(item)">
                                <i class="fa fa-user-md mr-2" aria-hidden="true"></i>
                                Profissionais
                            </button>
                            <button class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block" @click="abrirOperadoras ()">
                                <i class="far fa-credit-card mr-2"></i>
                                Operadoras
                            </button>
                            <button class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block" @click="abrirProcedimentos ()">
                                <i class="fas fa-play mr-2"></i>
                                Procedimentos
                            </button>
                            <button class="btn btn-outline-primary btn-sm mr-2 d-none d-lg-block" @click="abrirAgenda ()">
                                <i class="fas fa-calendar mr-2"></i>
                                Agendas
                            </button>
                        </div>
                    </nav>

                </div>

                <br><br>
            </div>

            <!-- Modal Operadoras -->
            <div class="modal fade" id="operadorasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content" v-if="operadoras_todas">
                        <div class="modal-header">
                            <h5 class="modal-title">Operadoras Habilitadas</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex flex-column mb-3">
                                <az-input
                                    type="button-group"
                                    :optionsList="[{ id: 'lista', search: 'Ativas' }, { id: 'edicao', search: 'Todas' }]"
                                    v-model="viewOper" />

                                <div v-if="viewOper == 'lista'">
                                    <ul class="list-group mt-3" v-if="operadoras_todas.filter(item => item.medico_operadora.fl_ativo).length">
                                        <li class="list-group-item" v-for="(oper, ip) in operadoras_todas.filter(item => item.medico_operadora.fl_ativo)" :key="ip">
                                            <a href="#" class="card-link" @click.prevent="$util.abrirOperadora(oper)">
                                                {{ oper.search }}
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="mt-3" v-else>
                                        <az-empty-state msg="Nenhuma operadora habilitada" icon="far fa-credit-card" />
                                    </div>
                                </div>

                                <!-- Edição -->
                                <div v-else>
                                    <div v-if="operadoras_todas.length" class="mt-3">
                                        <az-input
                                            type="checkbox-group"
                                            label="TODOS"
                                            v-model="marcarTodosOper"
                                            @click="marcar_operadoras ()" />

                                        <div v-for="(oper, ip) in operadoras_todas" :key="ip">
                                            <az-input
                                                type="checkbox-group"
                                                :label="oper.search"
                                                v-model="oper.medico_operadora.fl_ativo"
                                                @input="oper.medico_operadora.fl_ativo ? '' : ( marcarTodosOper = false )" />
                                        </div>

                                    </div>

                                    <div v-else>
                                        <az-empty-state msg="Nenhuma operadora disponível" icon="fa fa-play" />
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit v-if="viewOper == 'edicao'" @click="atualizar_operadoras()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Procedimentos -->
            <div class="modal fade" id="procedimentosModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Procedimentos Habilitados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="procedimentos && procedimentos.length">

                        <div class="d-flex flex-column mb-3">
                            <az-input
                                type="button-group"
                                :optionsList="[{ id: 'lista', search: 'Ativos' }, { id: 'edicao', search: 'Todos' }]"
                                v-model="viewProc" />
                        </div>

                        <az-input
                                type="select"
                                icon="fa fa-filter"
                                placeholder="Todas as especialidades..."
                                :optionsList="lista_proc_especialidades"
                                optionsMode="json"
                                optionsData="id_especialidade"
                                v-model="filtroproc.id_especialidade" />

                        <az-input
                            icon="fa fa-search"
                            placeholder="Pesquisar..."
                            v-model="filtroproc.search" />

                        <div v-if="viewProc == 'edicao'">

                            <div v-if="procedimentos_todos.length">

                                <az-input
                                    type="checkbox-group"
                                    label="TODOS"
                                    v-model="marcarTodosProc"
                                    @click="marcar_procedimentos ()" />

                                <div v-for="(proc, ip) in procedimentos_todos" :key="ip">
                                    <az-input
                                        type="checkbox-group"
                                        :label="proc.search + ' - ' + proc.especialidade.search"
                                        v-model="proc.medico_procedimento_unidades.fl_ativo"
                                        @input="proc.medico_procedimento_unidades.fl_ativo ? '' : ( marcarTodosProc = false )" />
                                </div>

                            </div>

                            <div v-else>
                                <az-empty-state msg="Nenhum procedimento disponível" icon="fa fa-play" />
                            </div>

                        </div>

                        <div v-else>

                            <ul class="list-group" v-if="procedimentos_todos.filter(item => item.medico_procedimento_unidades.fl_ativo).length">
                                <li class="list-group-item" v-for="(proc, ip) in procedimentos_todos.filter(item => item.medico_procedimento_unidades.fl_ativo)" :key="ip">
                                    <a href="#" class="card-link" @click.prevent="abrirProcedimento(proc)">
                                        {{ proc.search }}
                                    </a>
                                </li>
                            </ul>

                            <div v-else>
                                <az-empty-state msg="Nenhum procedimento habilitado" icon="fa fa-play" />
                            </div>

                        </div>

                        <pre v-if="1 == 0">{{ procedimentos_todos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="viewProc == 'edicao'" @click="atualizar_procedimentos()">Atualizar</az-submit>
                    </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="carregarAssinaturaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" v-if="1 == 0">
                <div class="modal-dialog" role="document">
                    <div class="modal-content" v-if="item">
                        <div class="modal-header">
                            <h5 class="modal-title">Assinatura</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                        </div>
                        <div class="modal-body">
                            <p>Carregar Certificado Digital A1, para permitir assinatura de documentos do prontuário. (Arquivo PFX)</p>

                            <az-single-image-loader
                                chave="pfx"
                                :titulo="item.tem_certificado ? 'Atualizar Certificado' : 'Carregar Certificado'"
                                :single="true"
                                :parms="{ model_type: 'medico', model_id: item.id_pessoa, cadastro_medico: true, tipo_especial: 'certificado' }"
                                extension="pfx"
                                mimetype="application/x-pkcs12"
                                service="medicos" />

                            <button class="btn btn-outline-primary" @click="solicitar_certificado = true" v-if="!solicitar_certificado">
                                Verificar certificado
                            </button>

                            <template v-else>

                                <az-input
                                    label="Chave"
                                    required
                                    v-model="chave_certificado"
                                    icon="fa fa-minus"
                                    :buttonIcon="true"
                                    buttonText="fa fa-minus"
                                    @clickButton="solicitar_certificado = false"
                                    type="password"
                                    :iconEnd="chave_certificado ? { color: 'outline-success', icon: 'fa fa-check' } : null"
                                    @clickButtonEnd="verificarCertificado ()" />

                                <template v-if="$store.state.loading">
                                    <div class="spinner-border mt-2" role="status">
                                    <span class="sr-only">Loading...</span>
                                    </div>
                                </template>
                                <template v-else-if="dados_certificado">
                                    <pre class="mt-2">{{ dados_certificado.subject }}</pre>
                                    <pre>Validade: {{ dados_certificado.validTo}}</pre>
                                </template>

                            </template>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <edicao-rateio-medico ref="editarrateio" @refresh="refresh_rateios()" />
            <medico-lista ref="medicolista" />
            <selecao-procedimento-prestador ref="selproc" :item="item" />

        </template>

	</div>
</template>

<script>

import _ from 'lodash';
import $ from 'jquery';

import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import EspecialidadesVinculadas from '../shared/EspecialidadesVinculadas.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSingleImageLoader from '../../util/AzSingleImageLoader.vue';
import VueMarkdown from 'vue-markdown'
import EdicaoRateioMedico from '../shared/EdicaoRateioMedico.vue';
import MedicoLista from '../../shared/MedicoLista.vue';
import SelecaoProcedimentoPrestador from '../shared/SelecaoProcedimentoPrestador.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import CadastroLaudoDistribuicao from './CadastroLaudoDistribuicao.vue';

export default {
    data () {
        return {
            filters: {},
            dialogVisible: false,
            selectedItem: null,
            item: null,
            geral: {},
            model: "",
            lista: { data: null },
            campos: [],
            campos_edicao: [],
            formErrors: [],
            edicao: [],
            chave: "",
            loading: true,
            last_page: 0,
            em_edicao: false,
            filhos: [],
            dados: {},
            reloading: false,
            search: "",
            firstLoadDone: false,
            breadcrumb: [],
            selectOptions: null,
            especialidade: "",
            validate: false,
            procedimentos: null,
            rateio: null,
            validateRateio: false,
            rateioNovaOperadora: null,

            procedimentos_todos: null,
            marcarTodosProc: false,
            viewProc: 'lista',

            operadoras_todas: null,
            marcarTodosOper: false,
            viewOper: 'lista',

            solicitar_certificado: false,
            chave_certificado: "",
            dados_certificado: null,

            exibir_repasse_ativos: true,

            lista_rateios: [],

            viewMode: 'A',

            filtroproc: {
                id_especialidade: "",
                search: "",
            },

            distribuicao: false, 
        }
    },

    watch: {
        '$store.state.unidade': function () {
            this.load();

            if ( this.item )
                this.editar (this.item);
        },

        id_medico: function () {
            if ( !this.id_medico && this.em_edicao ) {
                this.fechar();
            }
        },

    },

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubTitle,
        EspecialidadesVinculadas,
        AzSubmit,
        AzEmptyState,
        AzSingleImageLoader,
        VueMarkdown,
        EdicaoRateioMedico,
        MedicoLista, 
        SelecaoProcedimentoPrestador, 
        Formulario,
        CadastroLaudoDistribuicao
    },

    props: ['title','parentKey', 'parentModel', 'id_medico', 'link'],

    computed: {
        lista_proc_especialidades: function () {
            if ( !this.procedimentos_todos ) { 
                return [];
            }
            
            return _.sortBy(
                _.uniqBy(
                    this.procedimentos_todos.map(proc => proc.especialidade),
                    'id_especialidade'
                ),
                'search'
            );
        },

        lista_outros_participantes: function () {
            if ( !this.rateio || !this.rateio.outros_participantes )
                return [];

            return this.rateio.outros_participantes.filter(item => item.fl_ativo);
        },

        lista_rateios2 () {
            if ( !this.item )
                return [];

            return this.item.rateio_medicos.filter(item => item.fl_ativo || !this.exibir_repasse_ativos);
        },

        lista_childs_in () {
            if ( !this.campos.data.list_childs )
                return [];

            return _.filter(this.campos.data.list_childs, (item) => {
                        return item.mode == 'card';
                    });
        },
        lista_childs_tab () {
            if ( !this.campos.data.list_childs )
                return [];

            return _.filter(this.campos.data.list_childs, (item) => {
                        return item.mode != 'card';
                    });
        },
        lista_campos () {
            return this.campos.data.list_fields.filter((item) => {
                            return !item['hide'];
                        });
        },
        lista_dados () {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.lista && this.lista.data ) {
                return this.lista.data.filter(item => this.viewMode == 'T' || (item.medico_unidade && item.medico_unidade.fl_ativo))
                    .filter(item => {
                    return (
                        !this.especialidade || item.medico_especialidade.find(i => {
                            return i.id_especialidade == this.especialidade.id_especialidade;
                        })
                    ) && (
                        !this.search || reg.test(JSON.stringify(item))
                    )
                });
            }

            //return this.lista.data.data ? this.lista.data.data : [];
            return this.lista.data ? this.lista.data : [];
        }
    },
    methods: {
        medico_lista (item) {
            this.$refs.medicolista.abrir('medico', item.id_pessoa);
        },

        ativar_google_calendar() {
            if(this.item.cadastro.fl_google_calendar) {
                this.item.cadastro.fl_google_calendar = false;
                this.item.cadastro.st_google_calendar = '';
                return;
            }

            this.$util.atualizar (this, {
                service: 'medicos',
                func: 'ativar_google_calendar',
                dados: { st_google_calendar: this.item.cadastro.st_google_calendar },
                callback: (res) => {
                    if(res && res.status && res.status == 'OK') {
                        this.item.cadastro.fl_google_calendar = true;

                        this.$nextTick(() => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Atenção",
                                detail: "Calendário do google configurado com sucesso",
                                life: 3000
                            });
                        });
                    }
                },
            });
        },

        incluirParticipante (rateio) {
            rateio.outros_participantes.push({
                id_rateio_medico: null,
                id_unidade: 1,
                id_medico: "",
                fl_ativo: true,
                dc_porcentagem_medico: 0,
                dc_valor_medico: 0,
                in_regra_ordem: 1,
                ch_operadoras_lista: 'R',
                valor_fixo: false,
            });
        },

        refresh_rateios() {
            this.$util.loadItem(this, {
                service: 'medicos',
                func: 'show',
                parms: {
                    id: this.item.id_pessoa,
                    cadastro_medico: true,
                }
            })
            .then(res => {
                this.item.rateio_medicos = res.rateio_medicos;
                this.refresh_repasse_ativos();
            });
        },

        refresh_repasse_ativos() {
            if ( !this.item || !this.item.rateio_medicos )
                return [];

            this.lista_rateios = this.item.rateio_medicos.filter(item => item.fl_ativo || !this.exibir_repasse_ativos);
        },

        verificarCertificado () {

            this.$store.commit("loading", true);

            this.$util.loadItem(this, {
                service: 'medicos',
                func: 'dados_certificado',
                parms: {
                    id_medico: this.item.id_pessoa,
                    chave: this.chave_certificado,
                }
            })
            .then(res => {
                this.dados_certificado = res;
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        },

        abrirAssinatura () {
            this.solicitar_certificado = false;
            this.chave_certificado = "";
            this.dados_certificado = null;

            $('#carregarAssinaturaModal').modal('show');
        },

        atualizarOrdem () {

            this.$util.atualizar(this, {
                service: 'rateio_medicos',
                func: 'ordem',
                dados: {
                    lista: this.lista_rateios
                },
                toast: true,
            });

        },

        atualizar_operadoras () {
            this.$util.atualizar (this, {
                service: 'operadoras',
                func: 'vincular_medico',
                dados: {
                    ...this.operadoras_todas,
                },
                modal: 'operadorasModal',
            });
        },
        atualizar_procedimentos () {
            this.$util.atualizar (this, {
                service: 'procedimentos',
                func: 'vincular_medico',
                dados: {
                    ...this.procedimentos_todos,
                },
                modal: 'procedimentosModal',
            });
        },
        marcar_procedimentos () {
            this.procedimentos_todos.forEach(element => {
                element.medico_procedimento_unidades.fl_ativo = !this.marcarTodosProc;
            });
        },
        marcar_operadoras () {
            this.operadoras_todas.forEach(element => {
                element.medico_operadora.fl_ativo = !this.marcarTodosOper;
            });
        },
        incluirRateio () {
            this.$refs.editarrateio.incluir(this.item.id_pessoa);

            /*
            let item = {
                id_medico: this.item.id_pessoa,
                dt_data_vigencia: this.$util.hoje (),
                fl_ativo: true,
                in_dias_para_pagamento: 30,
                rateio_medico_operadoras: [],
                ch_operadoras_lista: "T",
                outros_participantes: [],
            };

            this.editarRateio(item);
            */
        },
        editarRateio (item) {
            this.$refs.editarrateio.editar(item.id_rateio_medico);

            /*
            this.rateio = null;
            this.rateioNovaOperadora = null;
            this.validate = false;

            this.$nextTick (() => {
                this.rateio = _.cloneDeep(item);
                $('#rateioModal').modal('show');
            });
            */
        },
        adicionarRateioOperadora () {
            if ( this.rateioNovaOperadora ) {

                this.rateio.rateio_medico_operadoras.push({
                    id_rateio_medico_operadora: null,
                    id_rateio_medico: this.rateio.id_rateio_medico,
                    id_operadora: this.rateioNovaOperadora.id_operadora,
                    search: this.rateioNovaOperadora.search,
                    selecionado: true,
                });

                this.$nextTick (() => {
                    this.rateioNovaOperadora =  null;
                })

            }
        },
        atualizarRateio () {
            this.$util.atualizar (this, {
                service: 'rateio_medicos',
                dados: { ...this.rateio },
                modal: 'rateioModal',
                callback: () => {
                    this.$util.loadItem(this, {
                        service: 'medicos',
                        func: 'show',
                        parms: {
                            id: this.item.id_pessoa,
                            cadastro_medico: true,
                        }
                    })
                    .then(res => {
                        this.item.rateio_medicos = res.rateio_medicos;
                        this.refresh_repasse_ativos();
                    });
                },
            });
        },
        removerRateio () {
            this.$util.remover (this, {
                service: 'rateio_medicos',
                dados: { ...this.rateio },
                modal: 'rateioModal',
                reload: true,
                callback: this.refresh,
            });
        },
        toggle_rateio (item) {
            if ( item.id_rateio_medico ) {
                this.$util.toggle (this, {
                    service: 'rateio_medicos',
                    dados: { ...item },
                });
            }
        },
        refresh () {
            this.editar (this.item);
        },
        editar (item) {
            let reload = item.id_pessoa ? true : false;

            this.validate = false;

            if ( !this.id_medico ) {
                this.$router.replace({ name: 'c-agendas-compartilhadas', params: { id_medico: item.id_pessoa }});
            }

            if ( item.id_pessoa ) {

                if ( !this.em_edicao ) {
                    this.$store.commit('loading', true);
                    this.item = null;
                    this.em_edicao = true;
                }

                let query = { q: [
                    {
                        name: 'medicos.show',
                        id: 'editar',
                        parms: {
                            id: item.id_pessoa,
                            cadastro_medico: true,
                            agenda_compartilhada: true,
                        }
                    },
                ]};

                this.axios.post('/aql', query)
                    .then(res => {

                        if ( res.data.editar.status == 200 ) {
                            let dados = res.data.editar.data;

                            this.lista_rateios = dados.rateio_medicos.filter(item => item.fl_ativo || !this.exibir_repasse_ativos);

                            if ( !dados.usuario ) {
                                dados.login = "";
                                dados.senha = "";
                                dados.senha_por_email = true;
                                dados.show_password = false;
                            }

                            if ( !dados.cadastro.dados_bancarios )
                                dados.cadastro.dados_bancarios = {
                                    id_cadastro: null,
                                    id_banco: null,
                                    in_agencia: null,
                                    in_conta: null,
                                    ch_digito_conta: null,
                                    st_observacoes: null,
                                };

                            this.item = dados;
                            this.em_edicao = true;

                            if ( this.item.search ) {
                                let bc = _.cloneDeep(this.breadcrumb);
                                bc.push({
                                    name: this.item.search,
                                    path: "/config/agendas-compartilhadas",
                                    route_name: "c-agendas-compartilhadas",
                                    params: {
                                        id_medico: this.item.id_pessoa
                                    }
                                });
                                this.$store.commit('setBreadcrumb', bc);
                            }

                            if ( !reload )
                                window.scrollTo(0,0);
                        }

                    })
                    .finally (() => {
                        this.$store.commit('loading', false);
                    });

            } else {

                this.item = { ...item };

                this.em_edicao = true;

                if ( this.item.search ) {
                    let bc = _.cloneDeep(this.breadcrumb);
                    bc.push({ name: 'Novo', path: "" });
                    this.$store.commit('setBreadcrumb', bc);
                }

                window.scrollTo(0,0);

            }

        },

        abrirAgenda () {

            this.$router.push({
                name: 'c-agendas',
                params: {
                    id_medico: this.item.id_pessoa,
                }
            });

        },

        abrirOperadoras () {

            this.viewOper = 'lista';

            this.$util.load(this, {
                service: 'operadoras',
                parms: {
                    id_medico: this.item.id_pessoa,
                },
                loadTo: res => {
                    this.operadoras_todas = res.map(item => {
                        if ( !item.medico_operadora ) {
                            item.medico_operadora = {
                                id_medico_operadora: null,
                                id_medico: this.item.id_pessoa,
                                id_operadora: item.id_operadora,
                                fl_ativo: false,
                            }
                        }
                        return item;
                    });
                    $('#operadorasModal').modal('show');
                }
            });

        },

        abrirProcedimentos () {
            this.$refs.selproc.abrirProcedimentos();

            /*
            this.viewProc = 'lista';

            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'medico_unidades.index',
                    id: 'procedimentos',
                    parms: {
                        cadastro_agenda: true,
                        where: {
                            id_medico: this.item.id_pessoa,
                        }
                    }
                },
                {
                    name: 'procedimentos.index',
                    id: 'procedimentos_todos',
                    parms: {
                        id_medico: this.item.id_pessoa,
                        lista_cadastro: true,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.procedimentos_todos.status == 200 ) {
                        this.procedimentos_todos = res.data.procedimentos_todos.data.map(item => {
                            if ( !item.medico_procedimento_unidades ) {
                                item.medico_procedimento_unidades = {
                                    id_medico_procedimento_unidade: null,
                                    id_medico_unidade: this.item.medico_unidade.id_medico_unidade,
                                    id_procedimento: item.id_procedimento,
                                    fl_ativo: false,
                                    in_tempo_atendimento: 30,
                                };
                            }
                            return item;
                        });
                    }

                    if ( res.data.procedimentos.status == 200 ) {
                        this.procedimentos = res.data.procedimentos.data.sort ((a, b) => {
                            return a.procedimento.search > b.procedimento.search ? 1 : -1;
                        });
                        $('#procedimentosModal').modal('show');
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });
            */
        },
        abrirProcedimento (proc) {
            this.$util.abrirProcedimento(proc);

            /*
            $('#procedimentosModal').modal('hide');

            this.$router.push({
                name: 'c-procedimentos',
                params: {
                    id_procedimento: proc.id_procedimento,
                }
            });
            */
        },
        getData (item, field) {
            return _.get(item, field);
        },
        addNewItem () {
            this.editar ({
                id_pessoa: null,
                id_estado_conselho: 26,
                pessoa: {},
                cadastro: {
                    dados_bancarios: {},
                    endereco: {},
                    telefone_cadastros: [],
                },
                medico_especialidade: [],
                login: "",
                senha: "",
                senha_por_email: true,
                show_password: false,
                medico_unidade: {
                    st_instrucao: "",
                },
                fl_agenda_compartilhada: true,
            });
        },
        saveForm () {
            this.$refs.cadForm.salvar ();
        },
        saveItem (item = null) {

            if ( item )
                this.item = item;

            this.reloading = true;

            let query = {
                    q: [
                        {
                            name: 'medicos.store',
                            parms: { ...this.item },
                            id: 'salvar'
                        }
                    ]
                };

            this.axios.post('aql', query)
                .then (res => {
                    if ( res.data.salvar && res.data.salvar.data && res.data.salvar.data.status_code > 400 ) {
                        let error = {
                                    response: {
                                        status: res.data.salvar.data.status_code,
                                        data: { errors: res.data.salvar.data.msg }
                                    }
                                };
                        this.handleError(error);
                    } else {
                        this.load();
                        if ( $("#cadastroModal") ) {
                            $("#cadastroModal").modal('hide');
                        }
                    }
                })
                .catch (() => {
                    this.loading = false;
                    this.reloading = false;
                });
        },
        deleteItem () {

            this.reloading = true;

            let query = {
                            q: [
                                {
                                    name: 'medicos.destroy',
                                    parms: { ...this.item },
                                }
                            ]
                        };

            this.axios.post('aql', query)
                .then (() => {
                    this.dialogVisible = false;
                    this.load();
                })
                .catch (err => {
                    this.loading = false;
                    this.reloading = false;
                    this.handleError(err);
                });
        },
        onRowSelect(event) {
            this.item = null;
            this.editar ({...event.data});
        },
        recarregar(page) {
            this.reloading = true;
            this.load(page);
        },
        loadOptions () {
            if ( this.selectOptions )
                return new Promise(function(resolve) {
                            resolve();
                        });

            let query = [];

            _.each(this.campos.data.edit_fields, (item) => {
                    if ( item.type == 'select' && item.aql )
                        query.push(item.aql);
                });

            _.each(this.campos.data.list_childs, (item) => {
                    _.each(item.metadados.edit_fields, (item) => {
                            if ( item.type == 'select' && item.aql )
                                query.push(item.aql);
                        });
                });

            query = { q: query };

            this.$store.commit('loading', true);

            return this.axios.post('aql', query)
                        .then (res => {
                            this.selectOptions = res.data;
                        })
                        .catch (err => {
                            this.handleError(err);
                        })
                        .finally (() => {
                            this.$store.commit('loading', false);
                        });
        },
        load (page = 1) {

            this.last_page = page;

            this.$store.commit('loading', true);

            let filtro_medico = ( this.id_medico && this.link ) ? { where: { id_pessoa: this.id_medico } } : {};

            let query = { q: [
                {
                    name: 'agenda_compartilhadas.index',
                    id: "lista",
                    parms: {
                        search: this.search,
                        cadastro_medico: true,
                        agenda_compartilhada: true,
                        ...filtro_medico,
                        cadastro: true,
                    }
                },
                {
                    name: 'medicos.create',
                    id: "campos"
                },
            ]};

            this.axios.post('aql', query)
                .then (res => {
                    if (res.data && res.data.lista.status == 200) {
                        this.lista = res.data.lista;
                        this.campos = res.data.campos;

                        if ( this.loading ) {
                            this.breadcrumb = [
                                    { name: "Configurações", path: "/cadastros"},
                                    { name: "Agendas Compartilhadas", path: "/config/agendas-compartilhadas", method: this.fechar }
                                ];
                            this.$store.commit('setBreadcrumb', this.breadcrumb);
                        }

                        if ( this.id_medico && this.lista.data.length == 1 && !this.em_edicao ) {
                            this.editar (this.lista.data[0]);
                        }
                    }

                    this.loading = false;

                })
                .catch (err => {
                    this.loading = false;
                    this.reloading = false;
                    this.handleError(err);
                })
                .finally (() => {
                    this.$store.commit('loading', false);
                    this.firstLoadDone = true;
                });
        },
        pesquisar () {
            this.reloading = true;
            this.load ();
        },
        incluir () {
            this.validate = false;
            this.edicao = { _novo: true };
        },
        atualizar () {

            // Duplicidade de Especialidade...

            if ( this.item.medico_especialidade ) {

                let testeDuplic = this.item.medico_especialidade.filter (item => !item.excluido );

                if ( testeDuplic.length != _.uniqBy(testeDuplic, 'id_especialidade').length ) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Especialidade duplicada.",
                        life: 3000
                    });

                    return;
                }

            }

            //

            this.$util.atualizar (this, {
                service: 'medicos',
                dados: this.item,
                reload: true,
                toast: true,
                callback: item => {
                    this.loadOptions ('especialidades.index', this.optionsName, { ativadas: true });
                    this.editar (item);
                }
            });


        },
        excluir (item) {
            this.axios.delete('/api/' + this.$props.model + '/' + item[this.chave])
                .then (() => {
                    this.carregar(this.last_page);
                })
                .catch (err => this.handleError(err));
        },
        fechar () {
            if ( this.id_medico && this.link ) {
                this.$router.go(-1);
            } else {
                this.$router.replace({ name: 'c-agendas-compartilhadas'});
                this.em_edicao = false;
                this.$store.commit('setBreadcrumb', this.breadcrumb);
                window.scrollTo(0,0);
            }
        },
        resolve(path, obj) {
            return path.split('.').reduce(function(prev, curr) {
                return prev ? prev[curr] : null
            }, obj || self);
        },
        toggle_medico (item) {
            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'medico_unidades.toggle',
                    id: 'toggle',
                    parms: {
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.toggle.status == 200 ) {
                        item = res.data.toggle.data;
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });


        }
    },
    mounted() {
        /*
        if ( this.id_medico && !this.link ) {
            this.link = true;
        }
        */

        this.model = this.$props.parentModel ? this.$props.parentModel : this.$route.params.model;
        this.load ();
    },

    updated () {
      $('[data-toggle="tooltip"]').tooltip();
    }
}

</script>
